module.exports = __webpack_public_path__ + "img/A-3029058-1573230408-9702.jpeg.5394ba30.jpg";